import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ActivityLogsApi - axios parameter creator
 * @export
 */
const ActivityLogsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Server-side filtering / sorting / paging via DevExtreme loadOptions. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (loadOptions, options = {}) => {
            const localVarPath = `/v1/ActivityLogs/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (loadOptions !== undefined) {
                for (const [key, value] of Object.entries(loadOptions)) {
                    localVarQueryParameter[key] = value;
                }
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ActivityLogsApi - functional programming interface
 * @export
 */
const ActivityLogsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ActivityLogsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Server-side filtering / sorting / paging via DevExtreme loadOptions. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(loadOptions, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(loadOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ActivityLogsApi - factory interface
 * @export
 */
const ActivityLogsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ActivityLogsApiFp(configuration);
    return {
        /**
         *
         * @summary Server-side filtering / sorting / paging via DevExtreme loadOptions. (Auth roles: System)
         * @param {DataSourceLoadOptions} [loadOptions]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(loadOptions, options) {
            return localVarFp.getAll(loadOptions, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ActivityLogsApi - object-oriented interface
 * @export
 * @class ActivityLogsApi
 * @extends {BaseAPI}
 */
class ActivityLogsApi extends BaseAPI {
    /**
     *
     * @summary Server-side filtering / sorting / paging via DevExtreme loadOptions. (Auth roles: System)
     * @param {DataSourceLoadOptions} [loadOptions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogsApi
     */
    getAll(loadOptions, options) {
        return ActivityLogsApiFp(this.configuration).getAll(loadOptions, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ActivityLogsApi, ActivityLogsApiAxiosParamCreator, ActivityLogsApiFactory, ActivityLogsApiFp };
//# sourceMappingURL=activity-logs-api.js.map
